import * as React from "react";
import type { SVGProps } from "react";
const SvgFlame = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 21.6c-3.97 0-7.2-3.042-7.2-6.781C4.8 9.6 12 2.4 12 2.4s7.2 7.2 7.2 12.419c0 3.739-3.23 6.781-7.2 6.781Zm0 0c-1.985 0-3.6-1.521-3.6-3.39C8.4 15.6 12 12 12 12s3.6 3.6 3.6 6.21c0 1.869-1.615 3.39-3.6 3.39Z"
    />
  </svg>
);
export default SvgFlame;
